import useQueryString from '@/src/Common/components/hooks/useQueryString';
import { useEffect } from 'react';
import usePicTime from './hooks/usePicTime';
import { Button } from '@/src/shadComponents/ui/button';

export default function PicTimeRedirectHandler() {
    const queryString = useQueryString();
    const { linkAccount, createPictimeFolder, addPhotoToGallery } =
        usePicTime();

    useEffect(() => {
        const getAccessToken = async () => {
            const accessToken = queryString.get('accessToken');

            if (accessToken) {
                const responst = await linkAccount(accessToken);
                console.log('Response', responst);
            }
        };

        getAccessToken();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div className="p-4 space-y-4">
            <h2 className="text-lg font-semibold tracking-tight text-foreground">PicTimeRedirectHandler</h2>
            <div className="flex gap-2">
                <Button variant="outline" onClick={() => createPictimeFolder('test')}>
                    Create Folder
                </Button>
                <Button variant="outline" onClick={() => addPhotoToGallery()}>
                    Add Photo
                </Button>
            </div>
        </div>
    );
}
